/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-console, no-alert */
import { call, select, fork, put, take } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import fir from 'firebase/app'
import moment from 'moment'
import _ from 'lodash'
import RestaurantActions from '../reducers/restaurantReducer'
import firebase from '../config/firebase'
import utils from '../utils'

export function* fetchRestaurant({ id }) {
  try {
    const restaurantRef = firebase.database().ref(`restaurants/${id}`)
    const response = yield call([restaurantRef, restaurantRef.once], 'value')

    if (response.val() !== null) {
      yield put(RestaurantActions.fetchRestaurantSuccess({ ...response.val(), key: id }))
    } else {
      yield put(RestaurantActions.fetchRestaurantError(null))
    }
  } catch (err) {
    yield put(RestaurantActions.fetchRestaurantError(err))
  }
}

const observerEvent = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        const restaurants = {}

        data.forEach(res => {
          restaurants[res.key] = res.val()
        })

        emit(restaurants)
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  })

  return listener
}

export function* fetchRestaurants() {
  const { region = utils.constants.REGION.PHNOM_PENH } = yield select(state => state.auth.data)
  const database = firebase.database()
  const restaurantsConnectionRef = database
    .ref('restaurants')
    .orderByChild('region')
    .equalTo(region)
  const databaseEventChannel = yield call(observerEvent, restaurantsConnectionRef)
  try {
    while (true) {
      const restaurants = yield take(databaseEventChannel)

      yield put(RestaurantActions.fetchRestaurantsConnected(restaurants))
    }
  } catch (err) {
    yield put(RestaurantActions.fetchRestaurantsError(err))
  } finally {
    databaseEventChannel.close()
  }
}

function* slackWebhook(status, name) {
  const worker = yield select(state => state.auth.data)

  const restoStatus = status === 'publish' ? `published` : 'drafted'

  const bodyRequest = {
    text: `${worker.username || 'Unknown'} just ${restoStatus} merchant: ${name}.\nDate: ${moment().format(
      'DD-MMM-YYYY hh:mm a'
    )}`,
  }

  fetch('https://hooks.slack.com/services/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', {
    method: 'POST',
    body: JSON.stringify(bodyRequest),
  }).catch(err => {

    console.log(err)
  })
}

function* branchSlackWebhook(merchantId, data) {
  const worker = yield select(state => state.auth.data)
  const merchants = yield select(state => state.restaurants.data)
  const merchantName = _.get(merchants, [merchantId, 'name'], 'N/A')

  const bodyRequest = {
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `${worker.username || 'Unknown'} just modified merchant branch: ${merchantName}-${
            data.name
          }.\nDate: ${moment().format('DD-MMM-YYYY hh:mm a')}`,
        },
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: JSON.stringify(data),
        },
      },
    ],
  }

  fetch('https://hooks.slack.com/services/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', {
    method: 'POST',
    body: JSON.stringify(bodyRequest),
  }).catch(err => {
    console.log(err)
  })
}

export function* saveRestaurant({ key, params, callBack }) {
  const { region = utils.constants.REGION.PHNOM_PENH } = yield select(state => state.auth.data)
  const databaseRef = firebase.database().ref()
  const updates = {}
  const categories = { ...params.categories, [region]: { ...params.categories, [region]: null } }

  updates[`restaurants/${key}/key`] = key
  updates[`restaurants/${key}/name`] = params.name
  updates[`restaurants/${key}/phone`] = params.phone
  updates[`restaurants/${key}/tier`] = Number(params.tier)
  updates[`restaurants/${key}/note`] = params.note
  updates[`restaurants/${key}/status`] = params.status
  updates[`restaurants/${key}/rate`] = Number(params.rate)
  updates[`restaurants/${key}/vat`] = Number(params.vat)
  updates[`restaurants/${key}/cooking_duration`] = Number(params.cooking_duration)
  updates[`restaurants/${key}/discount_rate`] = Number(params.discount_rate)
  updates[`restaurants/${key}/tags`] = params.tags
  updates[`restaurants/${key}/restricted_age`] = params.restricted_age
  updates[`restaurants/${key}/merchant_type`] = params.merchant_type
  updates[`restaurants/${key}/categories`] = categories
  updates[`restaurants/${key}/listing_orders`] = { [`all_${region}`]: 999 }
  updates[`restaurants/${key}/hide_item_image`] = params.hide_item_image
  updates[`restaurants/${key}/modified_at`] = fir.database.ServerValue.TIMESTAMP
  updates[`restaurants/${key}/region`] = region
  updates[`restaurants/${key}/query_key`] = `${region}-${params.merchant_type}-${params.status}`
  updates[`restaurants/${key}/mark_up_percentage`] = params.mark_up_percentage
  updates[`restaurants/${key}/reference_merchant_id`] = Number(params.reference_merchant_id)
  updates[`restaurants/${key}/search_keywords`] = params.search_keywords

  const { status, name } = params

  if (status === 'publish') {
    updates[`restaurants/${key}/last_published`] = fir.database.ServerValue.TIMESTAMP
  }

  if (utils.constants.env === 'PRD') {
    yield fork(slackWebhook, status, name)
  }

  try {
    yield call([databaseRef, databaseRef.update], updates)
    yield put(RestaurantActions.saveRestaurantSuccess({ key, ...params }))
    yield call(callBack)
  } catch (err) {
    yield put(RestaurantActions.saveRestaurantErorr(err))
  }
}

export function* deleteBranch({ storeId, branch }) {
  const databaseRef = firebase.database().ref()
  const updates = {}

  updates[`restaurants/${storeId}/branches/${branch.key}`] = null

  try {
    yield fork([databaseRef, databaseRef.update], updates)
  } catch (err) {
    alert(err)
  }
}

export function* saveBranch({ storeId, branchId, data, callBack }) {
  yield put(RestaurantActions.setBranchLoading(true))

  const updates = {}
  const databaseRef = firebase.database().ref()

  try {
    if (!data.created_at) {
      updates[`restaurants/${storeId}/branches/${branchId}/created_at`] = fir.database.ServerValue.TIMESTAMP
    }

    updates[`restaurants/${storeId}/branches/${branchId}/name`] = data.name
    updates[`restaurants/${storeId}/branches/${branchId}/lat`] = data.lat
    updates[`restaurants/${storeId}/branches/${branchId}/lng`] = data.lng
    updates[`restaurants/${storeId}/branches/${branchId}/order_phone`] = data.order_phone
    updates[`restaurants/${storeId}/branches/${branchId}/manager_phone`] = data.manager_phone
    updates[`restaurants/${storeId}/branches/${branchId}/address`] = data.address
    updates[`restaurants/${storeId}/branches/${branchId}/operation_type`] = data.operation_type
    updates[`restaurants/${storeId}/branches/${branchId}/monthly_report`] = data.monthly_report
    updates[`restaurants/${storeId}/branches/${branchId}/accept_online_payment`] = data.accept_online_payment
    updates[`restaurants/${storeId}/branches/${branchId}/merchant_settlement`] = data.merchant_settlement
    updates[`restaurants/${storeId}/branches/${branchId}/merchant_settlement_type`] = data.merchant_settlement_type
    updates[`restaurants/${storeId}/branches/${branchId}/aba_account_name`] = data.aba_account_name
    updates[`restaurants/${storeId}/branches/${branchId}/aba_account_number`] = data.aba_account_number
    updates[`restaurants/${storeId}/branches/${branchId}/schedules`] = data.schedules
    updates[`restaurants/${storeId}/branches/${branchId}/commission_rate`] = data.commission_rate || 0
    updates[`restaurants/${storeId}/branches/${branchId}/modified_at`] = fir.database.ServerValue.TIMESTAMP

    yield call([databaseRef, databaseRef.update], updates)
    yield put(RestaurantActions.setBranchLoading(false))
    yield put(RestaurantActions.setBranchData(storeId, branchId, data))
    yield call(callBack)

    if (utils.constants.env === 'PRD') {
      yield fork(branchSlackWebhook, storeId, data)
    }
  } catch (error) {
    alert(error)
    yield put(RestaurantActions.setBranchLoading(false))
  }
}

export function* getBranchOrders({ startAt, endAt }) {
  yield put(RestaurantActions.setBranchOrderLoading(true))

  const dbRef = firebase
    .database()
    .ref('orders')
    .orderByChild('created_at')
    .startAt(startAt)
    .endAt(endAt)
  try {
    const orders = {}
    const data = yield call([dbRef, dbRef.once], 'value')

    data.forEach(res => {
      orders[res.key] = res.val()
    })

    yield put(RestaurantActions.setBranchOrders(orders))
    yield put(RestaurantActions.setBranchOrderLoading(false))
  } catch (error) {
    alert(error)
    yield put(RestaurantActions.setBranchOrderLoading(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/restaurantSaga.js